import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ErrorCode, PublicQrDetails, QrGeneratorNavigatorVACANCY, UserLargeFileUploadModes } from 'shared-library';
import { PreparedPopupGeneratedRecordInterface } from '@app/store/models/prepared-popup-generated-record.interface';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { Subject } from 'rxjs';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';

@Component({
  selector: 'app-qrs-vacancy',
  templateUrl: './qrs-vacancy.component.html',
  styleUrls: ['./qrs-vacancy.component.scss', '../qrs-wrapper.component.scss']
})
export class QrsVacancyComponent implements OnInit {

  file_helper = {
    file: null,
    applied: false
  }

  steps = 0 // 0 for showing JD, 1 for filling application forms, 2 for Thanks for your application

  submitting = false

  data_ori: string
  @Input() qr_url: string;
  @Input() short_id: string
  data: QrGeneratorNavigatorVACANCY
  @Input() social_data: SocialHelper
  @Input() qr_details: PublicQrDetails
  @Output() _error = new EventEmitter<ErrorCode>()
  success_popup_obs: Subject<PreparedPopupGeneratedRecordInterface> = new Subject<PreparedPopupGeneratedRecordInterface>()

  constructor(
    public readonly coreService: CoreService,
    public readonly functionService: FunctionsService,
    private userQrGeneratorService: UserQrGeneratorService
  ) { }


  ngOnInit(): void {
    this.functionService.initializeTooltip()
    if (!this.short_id) {
      throw new Error("Short id is required");
    }
    if (!this.qr_details) {
      throw new Error("Qr Details is required");
    }
    this.data = this.qr_details.vacancy_data
    this.data_ori = JSON.stringify(this.data)
  }

  async startSubmit() {

    if (this.submitting) return

    if (!this.steps) {
      this.steps++
      return
    }
    if (this.file_helper.file && this.data.application.contact.name && this.functionService.isEmail(this.data.application.contact.email)) {

      this.submitting = true
      try {
        let b64 = await this.functionService.base64FromFile(this.file_helper.file)
        let ctype = this.file_helper.file.name.toLowerCase().endsWith(".pdf") ? "application/pdf" : "image/jpeg"
        this.data.application.contact.cv = await this.functionService.uploadFile(b64, this.file_helper.file.name.split(".").pop().toLowerCase(), UserLargeFileUploadModes.CV, ctype)

        await this.coreService.submitQRResponses(this.short_id, {
          contact: this.data.application.contact,
          meta: {
            name: this.file_helper.file.name,
            size: this.functionService.formatBytes(this.file_helper.file.size)
          },
          visit_info: this.userQrGeneratorService.visitInfo()
        })
        this.data = JSON.parse(this.data_ori)
        this.steps++
        this.file_helper.applied = true
      } catch (error) {
        this._error.emit(error?.message || ErrorCode.SOMETHING_WENT_WRONG_WHILE_PROCESSING_REQUEST)
      }
      this.submitting = false
    }

  }

  resetSteps() {
    this.steps = 0
    this.file_helper.file = null
    // this.file_helper.applied = false
  }

  fileChangedEvent(event: any) {
    if (event.target.files.length) {
      this.file_helper.file = event.target.files[0]
    }
  }

}
